import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  closeCreateStudent,
  openShowStudentDataModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getPaymentExceptionRequest } from "../../../../modules/admin-modules/payment/Actions";
import {
  createStudentRequest,
  editStudentRequest,
} from "../../../../modules/admin-modules/students/Actions";
// import ShowPassword from '../models/show-password'

const AddStudent = ({ isAdd, data, setSelectedData, setAddedStudent }) => {
  const openStudent = useSelector((state) => state.model.isOpen1);
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.students.isLoading);
  const paymentException = useSelector(
    (state) => state.payments.paymentException
  );

  const dispatch = useDispatch();

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const paymentExceptionOptions = paymentException?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      width: "100%",
      backgroundColor: "#FAF2EB",
      color: "#1e1b17",
      borderRadius: "12px",
      borderColor: state.isFocused ? "#6A1E1E" : "#D8CEC3",
      borderWidth: "1px",
      boxShadow: state.isFocused ? "0 0 0 1px rgba(106, 30, 30, 0.22)" : "none",
      minHeight: "42px",
      ":hover": {
        borderColor: "#6A1E1E",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (styles) => ({
      ...styles,
      color: "#D8CEC3",
      fontWeight: 600,
      fontSize: "14px",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#1e1b17",
      fontWeight: 600,
      fontSize: "14px",
    }),
    menu: (styles) => ({
      ...styles,
      borderRadius: "12px",
      overflow: "hidden",
      border: "1px solid #D8CEC3",
      boxShadow: "0 16px 40px rgba(74, 15, 31, 0.18)",
      zIndex: 50,
    }),
    option: (styles, state) => ({
      ...styles,
      fontSize: "14px",
      fontWeight: state.isSelected ? 800 : 600,
      color: state.isSelected ? "#E9E2DB" : "#4A0F1F",
      backgroundColor: state.isSelected
        ? "#4A0F1F"
        : state.isFocused
          ? "rgba(233, 226, 219, 0.7)"
          : "transparent",
      ":active": {
        backgroundColor: "rgba(216, 206, 195, 0.7)",
      },
    }),
  };

  useEffect(() => {
    if (openStudent) {
      dispatch(getAllGroupsRequest());
      dispatch(getPaymentExceptionRequest());
    }
  }, [openStudent]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color="#6A1E1E"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add New Student" : "Edit Student"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(74, 15, 31, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Fill in the required academic credentials
      </Text>
    </Box>
  );
  const onSubmit = (values) => {
    const editGroup = values?.student_group_id
      ? values?.student_group_id
      : data?.group?.id;
    console.log(editGroup);
    const newDate = values?.reservation_date
      ? dayjs(values?.reservation_date).format("YYYY-MM-DD")
      : dayjs(data?.created_at).format("YYYY-MM-DD");

    const action = (data) => {
      dispatch(closeCreateStudent());
      setAddedStudent(data);
      dispatch(openShowStudentDataModel());
      reset();
    };
    let formData = new FormData();
    for (let key in { ...values }) {
      // Skip null/undefined values - don't append them to FormData
      if (values[key] !== null && values[key] !== undefined) {
        formData.append(key, values[key]);
      }
    }
    // Explicitly handle payment_exception_id - if it's null, append empty string to allow backend to set it to NULL
    if (values.payment_exception_id === null) {
      formData.append("payment_exception_id", "");
    }
    formData.append("reservation_date", newDate);
    // Convert start_time to 12-hour format with AM/PM
    const startTime24 = values?.reservation_date.split("T")[1];
    let startTime12 = "";
    if (startTime24) {
      const [hourStr, minute, second] = startTime24.split(":");
      let hour = parseInt(hourStr, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12;
      startTime12 = `${hour}:${minute} ${ampm}`;
    }
    formData.append("start_time", startTime12);
    formData.append("student_group_id", `${editGroup}`);

    if (isAdd) dispatch(createStudentRequest(formData, action));
    else {
      formData.append("_method", "PUT");

      dispatch(
        editStudentRequest({
          id: data?.id,
          formData: formData,
          action: () => {
            dispatch(closeCreateStudent());
          },
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateStudent());
    setSelectedData && setSelectedData({});
    reset();
  };
  return (
    <>
      <MainModel
        header={header}
        closeFunc={closeFunc}
        openVar={openStudent}
        buttonTitle={null}
        isLoading={isLoading}
        buttonFunc={handleSubmit(onSubmit)}
        size="2xl"
        contentProps={{
          dir: "ltr",
          bg: "#E9E2DB",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "2xl",
        }}
        headerProps={{
          px: 8,
          pt: 8,
          pb: 6,
          borderBottom: "1px solid rgba(216, 206, 195, 0.5)",
        }}
        bodyProps={{ px: 8, py: 8 }}
        hideDefaultFooter={true}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={6} dir="ltr" w="100%">
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacingX={8}
              spacingY={6}
              alignItems="start"
            >
              <Box gridColumn="1 / -1">
                <MainInput
                  defaultValues={data?.name}
                  label="Student Name"
                  error={errors?.name?.message}
                  placeholder="Enter full name"
                  register={register}
                  name="name"
                />
              </Box>

              <MainInput
                defaultValues={data?.user_name}
                label="Code"
                error={errors?.user_name?.message}
                placeholder="AQ-XXXX"
                register={register}
                name="user_name"
                required={false}
              />

              <FormControl>
                <VStack align="stretch" spacing={2}>
                  <FormLabel
                    m={0}
                    fontSize="14px"
                    fontWeight="700"
                    color="#6A1E1E"
                    textAlign="left"
                  >
                    Group
                  </FormLabel>
                  <Select
                    inputId="student_group_id"
                    defaultValue={{
                      label: data?.group?.name,
                      value: data?.group?.id,
                    }}
                    options={groupsOptions}
                    onChange={(data) => {
                      setValue("student_group_id", data.value);
                    }}
                    styles={colourStyles}
                    placeholder="Select group"
                  />
                </VStack>
              </FormControl>

              <MainInput
                defaultValues={data?.phone}
                label="Phone"
                error={errors?.phone?.message}
                placeholder="+00 000 000"
                register={register}
                name="phone"
              />

              <MainInput
                defaultValues={data?.parent_phone}
                label="Parent Phone"
                error={errors?.parent_phone?.message}
                placeholder="+00 000 000"
                register={register}
                name="parent_phone"
              />

              <MainInput
                defaultValues={data?.assistant_phone}
                label="Assistant Phone"
                error={errors?.assistant_phone?.message}
                placeholder="+00 000 000"
                register={register}
                name="assistant_phone"
                required={false}
              />

              <MainInput
                defaultValues={data?.school}
                label="School"
                error={errors?.school?.message}
                placeholder="Enter school"
                register={register}
                name="school"
                required={false}
              />

              <MainInput
                type="datetime-local"
                label="Session Start"
                error={errors?.reservation_date?.message}
                placeholder="Select date"
                register={register}
                defaultValues={dayjs(data?.reservation_date).format(
                  "YYYY-MM-DDThh:mm"
                )}
                name="reservation_date"
                required={false}
              />

              <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
                <FormControl>
                  <VStack align="stretch" spacing={2}>
                    <FormLabel
                      m={0}
                      fontSize="14px"
                      fontWeight="700"
                      color="#6A1E1E"
                      textAlign="left"
                    >
                      Payment Exceptions
                    </FormLabel>
                    <Select
                      inputId="payment_exception_id"
                      defaultValue={{
                        label: data?.payment_exception?.name,
                        value: data?.payment_exception?.id,
                      }}
                      options={paymentExceptionOptions}
                      onChange={(data) => {
                        setValue("payment_exception_id", data ? data.value : null);
                      }}
                      styles={colourStyles}
                      placeholder="Select exception"
                      isClearable
                    />
                  </VStack>
                </FormControl>
              </Box>
            </SimpleGrid>

            <Flex justify="flex-end" gap={6} pt={4}>
              <Button
                variant="ghost"
                color="#4A0F1F"
                fontWeight="800"
                _hover={{ textDecoration: "underline" }}
                onClick={closeFunc}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                bg="#6A1E1E"
                color="white"
                borderRadius="lg"
                px={8}
                py={6}
                fontWeight="800"
                isLoading={isLoading}
                _hover={{ bg: "#4A0F1F" }}
                boxShadow="0 10px 24px rgba(106, 30, 30, 0.18)"
              >
                Save Changes
              </Button>
            </Flex>
          </Stack>
        </form>
      </MainModel>

      {/* <ShowPassword data={studentData} /> */}
    </>
  );
};

export default AddStudent;
